export default "__VITE_ASSET__DGjv4I9q__"